import React from "react";

import EditButton from "./EditButton";
import styles from "./PaymentProfileLabel.less";

const PaymentProfileLabel = ({ pp, onEditClick }) => (
  <div className={styles["label"]}>
    <div className={onEditClick ? styles["label-name-link"] : styles["label-name"]} onClick={onEditClick}>
      {pp.name}
      &nbsp;
      {onEditClick && <EditButton onlyIcon />}
    </div>
    <div className={styles["label-description"]}>
      {pp.has_additional_fee && (
        <div className={styles["installment"]} key="additional_fee">
          <div className={styles["installment-name"]}>
            {I18n.t("papp.components.PaymentProfileProductAttachmentFormSection.additional_fee")}:
          </div>
          <div className={styles["installment-description"]}>{pp.additional_fee_formatted}</div>
        </div>
      )}
      {pp.installments.map((installment, i) => (
        <div className={styles["installment"]} key={installment.uuid}>
          <div className={styles["installment-name"]}>
            {I18n.t("papp.components.PaymentProfileProductAttachmentFormSection.installment")} {i + 1}:
          </div>
          <div className={styles["installment-description"]}>{installment.description_formatted}</div>
        </div>
      ))}
    </div>
  </div>
);

export default PaymentProfileLabel;



// WEBPACK FOOTER //
// ./src/lib/components/PaymentProfileLabel.jsx